import {RegistrationApiGet, usePutRegistrationByIdMutation} from "./reg_api";
import {Alert, Button, Card, CardActions, CardContent, CardMedia, Typography} from "@mui/material";
import userPlaceholder from "/assets/imgs/user.jpg";
import {ListCardDataCol} from "../../components/styled";
import Delete from "@mui/icons-material/Delete";
import React from "react";
import useDownloadImage from "../storage/useDownloadImage";
import {Tables} from "../../apitypes";
import {useNavigate} from "react-router-dom";


interface Props {
    reg: RegistrationApiGet
}

export default ({reg}: Props) => {

    const avatarUrl = useDownloadImage("avatars", reg.worker?.avatar_url)
    const [put, {error, isLoading, reset}] = usePutRegistrationByIdMutation()
    const navigate = useNavigate();
    const worker: Tables<"worker"> | null= reg.worker ;
    return <Card sx={{
        display: "flex",
        backgroundColor: !reg.worker ?  "error.main": undefined
    }}>
        <CardMedia
            component="img"
            sx={{width: 120, height: 120, minWidth: 120, objectFit: "cover", }}
            image={avatarUrl || userPlaceholder}
            alt={worker?.lastName + " " + worker?.firstName}
            onClick={() => {
                if (reg.Status !== "RegFinished") {
                    navigate("./person")
                }
            }}
        />
        <ListCardDataCol>
            <CardContent sx={{width: "100%"}}>
                <Typography variant={"caption"}>Delavec</Typography>
                {worker && <Typography variant={"h6"}>{worker.lastName} {worker.firstName}</Typography>}
                {!worker && <Typography variant={"h6"}>N/A - izberi</Typography>}
                <Typography variant={"body1"}>{worker?.partnerCode}</Typography>
            </CardContent>
            <CardActions>
                {error && <Alert severity={"error"}>{error.message}</Alert>}
                {reg.Status != "RegFinished" && reg.worker && <Button
                    title="Odstrani osebo"
                    disabled={isLoading}
                    onClick={() => put({id: reg.id, body: {WorkerID: null}})}
                ><Delete fontSize={"small"}/> </Button>}

            </CardActions>
        </ListCardDataCol>

    </Card>
}
